import React from 'react';
import { List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@mui/icons-material';

import { purple, purpleish } from 'utils/color-styles';
import { Nonprofit } from 'generated/graphql';
import { renderAddress } from 'utils/renderAddress';

interface Props {
  selectedNonprofit: Nonprofit;
  isOutlined?: boolean;
  allowDeselection?: boolean;
  onClear?: () => void;
}
export const SelectedNonprofit = ({
  selectedNonprofit,
  isOutlined,
  allowDeselection,
  onClear,
}: Props) => (
  <List style={{ maxHeight: 560, overflow: 'auto' }}>
    <ListItem
      style={{
        backgroundColor: purpleish,
        borderRadius: isOutlined ? 16 : 0,
      }}
    >
      <ListItemText
        primary={
          <div style={{ display: 'flex' }}>
            <div style={{ color: purple }}>{selectedNonprofit.name}</div>{' '}
            {selectedNonprofit.ein ? <>&nbsp;–&nbsp;EIN: {selectedNonprofit.ein}</> : null}
          </div>
        }
        secondary={<>{renderAddress(selectedNonprofit.locationObject)}</>}
      />
      {allowDeselection && (
        <ListItemSecondaryAction>
          <IconButton edge="end" aria-label="delete" onClick={onClear}>
            <Close />
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  </List>
);
